import DateRange from "../DateRange";
import messageResource from "../messageResource"
import SelectionUpdater from "./SelectionUpdater";

export default class LockingSelectionUpdater extends SelectionUpdater{
    constructor(lockTable, selection, dateParser, selectionVeil){
        super(lockTable, selection, messageResource.getMessage("lock_tt.table.veil.locking"), selectionVeil);
        this.dateParser = dateParser;
    }

    handleResult(result)
    {
        let userRowsMap = [];
        let userRows = this.lockTable.getUserRows(this.selection.rowMin, this.selection.rowMax);
        for (let i = 0; i < userRows.length; i++)
        {
            let currentRow = userRows[i];

            let userId = currentRow.getHeaderCell().getValue().id;
            userRowsMap[userId] = currentRow;
        }

        let datesRow = this.lockTable.getDatesRow();
        let columnDates = [];
        for (let colIdx = this.selection.colMin; colIdx <= this.selection.colMax; colIdx++)
        {
            columnDates[colIdx] = datesRow.getCell(colIdx).getValue().date;
        }

        for (let i = 0; i < result.length; i++)
        {
            let userLock = result[i];
            let userRow = userRowsMap[userLock.lockedUserId];
            let dateRange = new DateRange(this.dateParser.parse(userLock.dateFrom), this.dateParser.parse(userLock.dateTo));

            for (let colIdx = this.selection.colMin; colIdx <= this.selection.colMax; colIdx++)
            {
                if (dateRange.contains(columnDates[colIdx]))
                {
                    let userDayInfo = userRow.getCell(colIdx).getValue();
                    userDayInfo.locked = true;
                    userDayInfo.whoLocked = userLock.whoLockedId;
                    userDayInfo.lockDate = this.dateParser.parse(userLock.whenLockedDate);
                }
            }
        }

        this.runnerController.regionLocked(this.lockTable, this.selection);
    }
}



// WEBPACK FOOTER //
// ./web/js/locktable/LockingSelectionUpdater.js